import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ["dialog", "processing", "success", "error", "downloadLink", "errorMessage"]

  start(event) {
    event.preventDefault()
    this.showState("processing")
    this.dialogTarget.showModal()
    this.initiateDownload()
  }

  initiateDownload() {
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => this.subscribeToDownload(data.download_id))
      .catch(error => this.showErrorState(error.message || "An unexpected error occurred"))
  }

  subscribeToDownload(downloadId) {
    this.subscription = window.Cable.subscriptions.create(
      { channel: "DownloadsChannel", download_id: downloadId },
      {
        received: (data) => this.handleDownloadUpdate(data)
      }
    )
  }

  handleDownloadUpdate(data) {
    if (data.status === "generated") {
      this.downloadLinkTarget.href = data.url
      this.showState("success")
      this.unsubscribe()
    } else if (data.status === "errored") {
      this.showErrorState(data.error)
      this.unsubscribe()
    }
  }

  showState(state) {
    this.processingTarget.classList.toggle("hidden", state !== "processing")
    this.successTarget.classList.toggle("hidden", state !== "success")
    this.errorTarget.classList.toggle("hidden", state !== "error")
  }

  showErrorState(message) {
    if (message) {
      this.errorMessageTarget.textContent = message
    }
    this.showState("error")
  }

  close() {
    this.dialogTarget.close()
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  disconnect() {
    this.unsubscribe()
  }
}
